import React from 'react';

import { Callout } from '@blueprintjs/core';
import { FormGroup, InputGroup, Button, Label } from "@blueprintjs/core";
import TableTickets from './TableTickets';
import { getCronDateLookup } from './lookup';
import { Trans } from 'react-i18next';
import { authenticatedPostFetchWithResult } from "../../utils/AuthenticatedFetch";
import { saveAs } from "file-saver";

export default class BonificationList extends React.Component {
  constructor(props) {
    super();
    this.state = {
      vendorMostBonification: {},
      userMostBonification: {},
      discountMostUsed: [{}],
      ticketDiscountedTotal: undefined,
      ticketDiscountedToday: undefined,
      cronDate: undefined,
      crontractLife: undefined,
      dateStart: '',
      dateEnd:''
    };
  }


  async componentDidMount() {
    const cronDate = await getCronDateLookup();
    this.setState({ cronDate })
  }

  exportDataButtonState() {
    return !(this.state.dateEnd?.length > 0 && this.state.dateStart?.length > 0);
  }
  render() {
    return (
      <Callout intent="info">
        {this.state.cronDate &&
          <>
            <p><Trans>last bonitick synchronisation</Trans>: {this.state.cronDate}</p>
            <div>
              <FormGroup style={{ marginLeft: "1rem" }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                    <Label htmlFor="startDate"><Trans>start date</Trans></Label>
                    <InputGroup
                      id="startDate"
                      type="date"
                      placeholder="YYYY-MM-DD"
                      onChange={(e) => this.setState({dateStart: e.target.value})}
                    />
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                    <Label htmlFor="endDate"><Trans>end date</Trans></Label>
                    <InputGroup
                      id="endDate"
                      type="date"
                      placeholder="YYYY-MM-DD"
                      onChange={(e) => this.setState({dateEnd: e.target.value})}
                    />
                  </div>

                  <div style={{ justifySelf: "flex-end", alignSelf: "flex-end", marginLeft: "1rem" }}>
                    <Button
                      intent="normal"
                      icon="export"
                      disabled={this.exportDataButtonState()}
                      onClick={() => {
                        authenticatedPostFetchWithResult("/bonification/exportData", { dateStart: this.state.dateStart, dateEnd: this.state.dateEnd, format: "csv" }, (response, data) => {
                          saveAs(new Blob([data], { type: "text/csv;charset=utf-8" }), `bonitick_${this.state.dateStart}_${this.state.dateEnd}.csv`);
                        }, () => { }, true);
                      }}><Trans>export</Trans></Button>
                  </div>
                </div>
              </FormGroup>
            </div>
            <TableTickets />
          </>
        }
      </Callout >
    );
  }

}
